var render = function render(){var _vm=this,_c=_vm._self._c;return _c('blockquote',{ref:"blockquote",staticClass:"admonition",class:_vm.getTypeClass(_vm.type)},[_c('p',[(_vm.title)?_c('strong',{staticClass:"admonition-title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]):_vm._e(),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }